import script from "./UserSubscriptionCancel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSubscriptionCancel.vue?vue&type=script&setup=true&lang=js"

import "./UserSubscriptionCancel.vue?vue&type=style&index=0&id=cf66c754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf66c754"]])

export default __exports__